<template>
  <section>
    <LmComponentLoading v-if="isLoading" />
    <div v-if="EChartSettings">
      <v-chart :key="key" class="chart" :option="EChartSettings" :init-options="initOptions" />
    </div>
    <div v-else>
      <LmSvgIcon
        v-if="error"
        wrapperClass="d-flex h-100 justify-content-center align-items-center flex-column"
        width="12em"
        icon="LmErrorIcon"
        text="No pudimos cargar el Widget."
      />
      <template v-else>
        <h4>Configura tu gráfico</h4>
        <p>Comienza a configurar tu gráfico desde el panel izquierdo para poder visualizarlo aquí mismo.</p>
      </template>
    </div>
  </section>
</template>

<script>
// Component
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'
import 'zrender/lib/svg/svg'

// Utils
import commonsApi from '@/api/commons'

use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent
])

export default {
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: 'ligth'
  },
  props: {
    widget: {
      type: Object
    },
    customization: {
      type: Object
    },
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      error: false,
      isLoading: false,
      EChartSettings: null,
      initOptions: {
        renderer: 'svg'
      },
      key: 0
    }
  },
  methods: {
    renderData (data) {
      const namesArr = data.map(el => el.name)
      const valuesArr = data.map(el => el.value)
      const seriesArr = data.map(el => ({ name: el.name, type: 'bar' }))
      const title = this.widget.title || this.widget.datatableAlias

      this.EChartSettings = {
        grid: {
          top: 95
        },
        // Propiedades para modificar el tooltip
        // https://echarts.apache.org/en/option.html#tooltip.formatter
        tooltip: {
          formatter: function (params) {
            return `
              ${params.name}<br />
              <div>
                <span style="color: ${params.color}">&#11044;</span>
                ${params.seriesName}
                <b style="float: right; margin-left: 20px">${params.data[params.seriesIndex + 1]}</b>
              </div>
            `
          }
        },
        legend: {
          left: 'left',
          top: 40,
          data: namesArr
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          minInterval: 1
        },
        dataset: {
          source: [
            ['names', ...namesArr],
            [title, ...valuesArr]
          ]
        },
        // series: Array.from({ length: data.length}, _ => ({ type: 'bar' }))
        series: seriesArr
      }
      if (!this.hideTitle) {
        this.EChartSettings.title = {
          text: title,
          left: 'center'
        }
      }
      // NOTA. Fix temporal solo para modo edicion al cambiar entre aggsToRender
      this.key++
    },
    async loadData (datatable, term) {
      try {
        this.isLoading = true
        this.error = false
        const res = await commonsApi.axiosPostWrapper('/widgets/generate-chart', {
          id: datatable.id,
          term: term
        })

        if (!this.widget.title) {
          this.widget.title = res.data.title
        }

        this.renderData(res.data.items)
      } catch (error) {
        console.log(error)
        this.EChartSettings = null
        this.error = true
      } finally {
        this.isLoading = false
      }
    }
  },
  watch: {
    widget: {
      deep: true,
      async handler (val) {
        if (val.aggTerm && val.dataOrigin) {
          await this.loadData(val.dataOrigin, val.aggTerm)
        } else {
          this.EChartSettings = null
        }
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      if (this.widget.dataOrigin && this.widget.aggTerm) {
        await this.loadData(this.widget.dataOrigin, this.widget.aggTerm)
      } else {
        this.EChartSettings = null
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
.chart {
  height: 400px;
}
</style>
